
import Vue from "vue";

export default Vue.extend({
  props: {
    accountOffer: {
      type: Object
    }
  }
});
